// Company billing data - POST ********************************************************************
// pathname: /v1/company/billing-data
// ************************************************************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';

/**
 * @description Props
 */
interface UseSwrPostBillingDataProps {
  locale: Locale;
  successCallback?: () => Promise<void>;
}

/**
 * @description SWR: fetch company billing data
 * - `locale:` *string* - The current app locale.
 * - `successCallback:` *function* - The callback to execute after the fetch.
 */
export const useSwrPostBillingData = (props: UseSwrPostBillingDataProps) => {
  // Destructure props
  const {
    locale,
    successCallback,
  } = props;


  // SWR: fetch data
  const {
    data, error, trigger, reset, isMutating,
  } = useSwrMutationApi<unknown, ApiSchema<'BillingDataWrite'>>({
    url: '/v1/company/billing-data',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) {
          void successCallback();
        }
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  // Return data
  return {
    data,
    error,
    trigger,
    reset,
    isMutating,
  };
};
